<template>
  <div id="codelist">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'codelist'
}
</script>




// WEBPACK FOOTER //
// src/views/system/codelist/Codelist.vue